import React from 'react'
import styled from 'styled-components'

import Avatar from '../../../display/Avatar'
import LazyImage from '../../../display/LazyImage'

const LiteAvatar = styled(Avatar)`
  height: 25px;
  width: 25px;
  margin-right: 6px;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme?.['-ds-neutral-100']?.value};
`

const Outer = styled.div<{ compact?: boolean }>`
  display: flex;
  align-items: center;
  width: fit-content;

  border-radius: 80px;
  background-color: rgba(29, 29, 29, 0.6);
  color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  font-size: ${({ theme, compact }) =>
    compact
      ? theme?.['-ds-font-size-xxxs']?.['font-size']?.value
      : theme?.['-ds-font-size-xxs']?.['font-size']?.value};
  padding: ${({ compact }) => (compact ? '4px 8px 4px 4px' : '8px')};
  font-weight: 400;
`

type Props = {
  storytellerName: string
  avatarUrl: string
  compact?: boolean
}

const StorytellerCreditLite = ({
  storytellerName,
  avatarUrl,
  compact,
}: Props) => {
  return (
    <Outer compact={compact}>
      <LiteAvatar>
        <LazyImage data-src={avatarUrl} alt={storytellerName} />
        <noscript>
          <LazyImage
            className="lazyload"
            src={avatarUrl}
            alt={storytellerName}
          />
        </noscript>
      </LiteAvatar>
      <span>Story by {storytellerName}</span>
    </Outer>
  )
}

export default StorytellerCreditLite
